/* BEGIN GENERATED VSR VISUAL CONTRACT */
/* VSR visual contract. Shared by the player, shop and crop editor. */
(function(root){
  'use strict';
  const clamp=(n,min,max)=>Math.max(min,Math.min(max,n));
  function pick(items,random=Math.random,excluded=new Set()){
    if(!items || !items.length)return null;
    if(excluded.size){
      const choices=items.map((value,i)=>({value,weight:items.length===1?1:i===0?.4:.6/(items.length-1)})).filter(item=>!excluded.has(item.value));
      let draw=random()*choices.reduce((sum,item)=>sum+item.weight,0);
      for(const item of choices){draw-=item.weight;if(draw<0)return item.value;}
      return choices.at(-1)?.value||null;
    }
    if(items.length===1)return items[0];
    const draw=clamp(random(),0,1-Number.EPSILON);
    return items[draw<.4?0:1+Math.floor((draw-.4)/.6*(items.length-1))];
  }
  function record(value){
    if(!value)return null;
    if(typeof value!=='string')return value;
    const url=new URL(value,'https://play.voyagersoundrecords.com');
    const item={src:value,x:Number(url.searchParams.get('fx')??50),y:Number(url.searchParams.get('fy')??50)};
    const width=Number(url.searchParams.get('iw')||0),height=Number(url.searchParams.get('ih')||0);
    if(width>0&&height>0){item.width=width;item.height=height;}
    return item;
  }
  function freshPick(items,key,random=Math.random,storage){
    const unique=[...new Map((items||[]).filter(Boolean).map(v=>[record(v)?.src,v])).values()];
    if(!unique.length)return null;
    let previous='';
    try{storage=storage||root.sessionStorage;previous=storage?.getItem('vsr-logo:'+key)||'';}catch(e){}
    const alternatives=unique.filter(v=>record(v)?.src!==previous);
    const selected=pick(alternatives.length?alternatives:unique,random);
    try{storage?.setItem('vsr-logo:'+key,record(selected).src);}catch(e){}
    return selected;
  }
  function rolePool(items,role){
    if(!items || !items.length || role!=='banner')return items||[];
    const wide=items.filter(value=>{const item=record(value);return item?.width>0&&item?.height>0&&item.width/item.height>=1.6;});
    return wide.length?wide:items;
  }
  function geometry(iw,ih,w,h,x=50,y=50){
    if(!iw||!ih||!w||!h)return {left:0,top:0,width:w,height:h,px:50,py:50};
    const scale=Math.max(w/iw,h/ih),width=iw*scale,height=ih*scale;
    const ox=Math.max(0,width-w),oy=Math.max(0,height-h);
    const left=clamp(w/2-width*clamp(x,0,100)/100,-ox,0);
    const top=clamp(h/2-height*clamp(y,0,100)/100,-oy,0);
    return {left,top,width,height,px:ox?-left/ox*100:50,py:oy?-top/oy*100:50};
  }
  function crop(img){
    if(!img.naturalWidth || !img.clientWidth || !img.clientHeight)return;
    if(img.dataset.vsrRole==='logo'){img.style.objectFit='contain';img.style.objectPosition='50% 50%';return;}
    const g=geometry(img.naturalWidth,img.naturalHeight,img.clientWidth,img.clientHeight,+img.dataset.vsrX,+img.dataset.vsrY);
    img.style.objectFit='cover';img.style.objectPosition=g.px+'% '+g.py+'%';
    // No hidden overscale: editor and public frame must have identical crops.
    img.style.transform='none';
  }
  const bound=new WeakSet();
  const observer=typeof ResizeObserver==='function'?new ResizeObserver(rows=>rows.forEach(r=>crop(r.target))):null;
  function apply(img,value,role){
    const item=record(value);if(!img||!item?.src)return;
    img.dataset.vsrX=clamp(Number(item.x??50),0,100);
    img.dataset.vsrY=clamp(Number(item.y??50),0,100);
    img.dataset.vsrRole=role||img.dataset.vsrRole||item.role||'';
    if(img.getAttribute('src')!==item.src){img.removeAttribute('srcset');img.src=item.src;}
    if(!bound.has(img)){bound.add(img);img.addEventListener('load',()=>{if(img.isConnected)observer?.observe(img);crop(img);});}
    if(img.isConnected)observer?.observe(img);
    crop(img);
  }
  function release(host){host.querySelectorAll('img').forEach(img=>observer?.unobserve(img));}
  function scan(host=document){
    host.querySelectorAll('img[data-vsr-pool],img[data-vsr-x],img[src*="/assets/artists/visuals/"]').forEach(img=>{
      let value=img.getAttribute('src');
      const hintedRole=img.dataset.vsrRole||img.closest('[data-image-role]')?.dataset.imageRole||value?.match?.(/-(main|editorial|banner|logo)-\d+/)?.[1];
      if(img.dataset.vsrPool && !img.dataset.vsrSelected){
        try{value=pick(rolePool(JSON.parse(img.dataset.vsrPool),hintedRole));img.dataset.vsrSelected='1';}catch(e){return;}
      }else if(img.dataset.vsrX)value={src:value,x:+img.dataset.vsrX,y:+img.dataset.vsrY};
      const role=hintedRole||value?.match?.(/-(main|editorial|banner|logo)-\d+/)?.[1];
      apply(img,value,role);
    });
    const used=new Set([...host.querySelectorAll('.artist-frame.role-editorial img')].map(img=>img.getAttribute('src')));
    host.querySelectorAll('img[data-vsr-journal]').forEach(img=>{
      if(img.dataset.vsrSelected)return;
      const pool=JSON.parse(img.dataset.vsrJournal);
      const value=pick(pool,Math.random,used);if(!value){img.closest('figure').hidden=true;return;}
      used.add(value);img.dataset.vsrSelected='1';apply(img,value,'editorial');
    });
  }
  function placements(role,viewport=1440){
    const mobile=viewport<=1000,home=Math.min(1440,viewport)-(viewport<=520?24:44);
    const artist=Math.min(1320,viewport)-(viewport<=768?28:44);
    const frame=(label,width,ratio,shade=false)=>{const [x,y]=ratio.split(':').map(Number);return {label,width,height:width*y/x,ratio,shade};};
    if(role==='banner')return [frame('Player · landing / releases',home*(mobile?1:.75),mobile?'16:9':'3:2',!mobile),frame('Player · artist banner',artist*(mobile?1:.75),mobile?'16:9':'3:2',!mobile),frame('Shop · artist collection',viewport,viewport<=1100?'16:9':'21:9')];
    if(role==='logo')return [frame('Player · Visual notes',viewport<=768?68:88,'1:1'),frame('Shop · collection signature',80,'1:1')];
    if(role==='main')return [frame('Player · artist index',home/(viewport<=640?2:viewport<=820?4:5),'1:1'),frame('Player · supporting artist',home*(mobile?.5:.25),'1:1'),frame('Shop · artist index',Math.min(viewport-40,1500)/(viewport<=749?2:4),'1:1'),frame('Shop · discovery portrait',Math.min(viewport-40,1500)/(viewport<=749?2:3),'4:5')];
    return [frame('Player · supporting editorial',artist*(mobile?.5:.25),'1:1'),frame('Player · Visual notes',artist/(viewport<=520?2:3),'4:5'),frame('Player · release visual world',artist/(viewport<=768?1:3),'4:3'),frame('Shop · discovery portrait',Math.min(viewport-40,1500)/(viewport<=749?2:3),'4:5')];
  }
  const api={version:'2026-09-19.1',pick,freshPick,record,rolePool,geometry,apply,crop,scan,release,placements};
  root.VSRVisuals=api;
  if(typeof module==='object')module.exports=api;
  if(typeof document!=='undefined'){
    document.addEventListener('DOMContentLoaded',()=>scan());
    document.addEventListener('load',event=>{const img=event.target;if(img.tagName==='IMG'&&img.src.includes('/assets/artists/visuals/'))apply(img,img.getAttribute('src'));},true);
  }
})(typeof window!=='undefined'?window:globalThis);

/* END GENERATED VSR VISUAL CONTRACT */
/* ==========================================================================
   VSR Editorial — behaviour for everything below the hero.
   Enhances what the theme already renders rather than replacing sections, so
   it survives theme edits and Shopify's own section markup.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- randomized editorial media ---------- */
  function randomUnit() {
    if (window.crypto && window.crypto.getRandomValues) {
      var value = new Uint32Array(1);
      window.crypto.getRandomValues(value);
      return value[0] / 4294967296;
    }
    return Math.random();
  }

  function sample(items, count) {
    var shuffled = Array.prototype.slice.call(items);
    for (var i = shuffled.length - 1; i > 0; i--) {
      var j = Math.floor(randomUnit() * (i + 1));
      var hold = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = hold;
    }
    return shuffled.slice(0, Math.min(count, shuffled.length));
  }

  function replaceChildren(host, nodes) {
    while (host.firstChild) host.removeChild(host.firstChild);
    nodes.forEach(function (node) { host.appendChild(node); });
  }

  function cloneTemplate(template) {
    if (!template || !template.content || !template.content.firstElementChild) return null;
    return template.content.firstElementChild.cloneNode(true);
  }

  var approvedImageCache;

  function approvedRecords(values) {
    if (!Array.isArray(values)) return [];
    return values.map(function (value) {
      return typeof value === 'string' ? {src: value, x: 50, y: 50} : value;
    }).filter(function (value) {
      return value && typeof value.src === 'string' && value.src.trim();
    });
  }

  function scanApprovedImages(root) {
    if (window.VSRVisuals) window.VSRVisuals.scan(root);
  }

  function approvedImages() {
    if (approvedImageCache) return approvedImageCache;
    approvedImageCache = {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-vsr-approved-images]'), function (node) {
      try {
        var parsed = JSON.parse(node.textContent || '{}');
        Object.keys(parsed).forEach(function (handle) {
          var value = parsed[handle];
          /* Legacy untyped portraits may serve square slots, but never
             acquire approval for the separate banner or logo roles. */
          if (Array.isArray(value)) {
            var portraits = approvedRecords(value);
            approvedImageCache[handle] = {main:portraits, editorial:portraits, banner:[], logo:[]};
          } else if (value && typeof value === 'object') {
            approvedImageCache[handle] = {
              main: approvedRecords(value.main),
              editorial: approvedRecords(value.editorial),
              banner: approvedRecords(value.banner),
              logo: approvedRecords(value.logo)
            };
          }
        });
      } catch (error) {
        /* Keep the established collection portrait if the generated map is malformed. */
      }
    });
    return approvedImageCache;
  }

  function applyApprovedImage(node, role, strictRole) {
    if (!node) return node;
    var handle = node.dataset.vsrArtistHandle || '';
    var sets = approvedImages()[handle];
    var fallbackRoles = strictRole ? [role] : role === 'banner' ? ['banner']
      : role === 'main' ? ['main','editorial']
      : role === 'editorial' ? ['editorial','main'] : [];
    var images = null;
    var selectedRole = role;
    if (sets) fallbackRoles.some(function (name) {
      if (sets[name] && sets[name].length) {
        images = sets[name];
        selectedRole = name;
        return true;
      }
      return false;
    });
    var image = node.querySelector && node.querySelector(
      node.matches('.vsr-page-hero--collection') ? '.vsr-page-hero__collection-image' : 'img');
    if (!image) return node;
    if (!images || !images.length) {
      if (strictRole || role === 'banner') {
        image.removeAttribute('src');
        image.removeAttribute('srcset');
        image.hidden = true;
      }
      return node;
    }
    if (!window.VSRVisuals) return node;
    var selected = window.VSRVisuals.pick(images, randomUnit);
    if (!selected || !selected.src) return node;
    image.removeAttribute('srcset');
    image.hidden = false;
    window.VSRVisuals.apply(image, selected, selectedRole);
    node.dataset.vsrApprovedApplied = selectedRole;
    return node;
  }

  function applyApprovedLeads() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vsr-artist-handle]'), function (node) {
      if (node.tagName === 'TEMPLATE' || node.hasAttribute('data-vsr-approved-logo') ||
          node.dataset.vsrApprovedApplied) return;
      var role = node.dataset.vsrImageRole || node.dataset.imageRole || (node.matches('.vsr-page-hero--collection') ? 'banner' : 'main');
      applyApprovedImage(node, role);
    });
  }

  function applyApprovedLogos() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vsr-approved-logo]'), function (host) {
      if (host.dataset.vsrApprovedApplied === 'logo') return;
      var handle = host.dataset.vsrArtistHandle || '';
      var sets = approvedImages()[handle];
      var logos = sets && Array.isArray(sets.logo) ? sets.logo : [];
      var image = host.querySelector('img');
      if (!image || !logos.length || !window.VSRVisuals) return;
      var selected = window.VSRVisuals.freshPick(logos, handle, randomUnit);
      if (!selected || !selected.src) return;
      host.hidden = false;
      image.removeAttribute('srcset');
      window.VSRVisuals.apply(image, selected, 'logo');
      host.dataset.vsrApprovedApplied = 'logo';
    });
  }

  function randomizeArtists() {
    var pool = Array.prototype.filter.call(
      document.querySelectorAll('template[data-vsr-artist-template]'),
      function (template) { return template.dataset.vsrArtistHandle !== 'beboo'; }
    );
    if (!pool.length) return;

    Array.prototype.forEach.call(document.querySelectorAll('[data-vsr-random-artists]'), function (grid) {
      if (grid.dataset.vsrRandomized) return;
      var cards = sample(pool, 6).map(function (template) {
        return applyApprovedImage(cloneTemplate(template), 'editorial');
      }).filter(Boolean);
      if (cards.length) {
        replaceChildren(grid, cards);
        scanApprovedImages(grid);
        grid.dataset.vsrRandomized = '1';
      }
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-vsr-random-artist-hero]'), function (mosaic) {
      if (mosaic.dataset.vsrRandomized) return;
      // This collage is Editorial-only; roster cards retain their Main role.
      var editorialPool = pool.filter(function (template) {
        var sets = approvedImages()[template.dataset.vsrArtistHandle];
        return sets && sets.editorial.length;
      });
      var tiles = sample(editorialPool, 6).map(function (template, index) {
        var card = applyApprovedImage(cloneTemplate(template), 'editorial', true);
        var source = card && card.querySelector('img');
        if (!source || card.dataset.vsrApprovedApplied !== 'editorial') return null;
        var tile = document.createElement('div');
        tile.className = 'vsr-page-hero__tile vsr-page-hero__tile--' + (index + 1);
        tile.dataset.vsrArtistHandle = template.dataset.vsrArtistHandle || '';
        tile.dataset.vsrImageRole = 'editorial';
        tile.dataset.vsrApprovedApplied = card.dataset.vsrApprovedApplied || '';
        var image = source.cloneNode(true);
        image.alt = '';
        image.sizes = '(max-width: 749px) 42vw, 24vw';
        if (index < 2) {
          image.removeAttribute('loading');
          image.setAttribute('fetchpriority', 'high');
        }
        tile.appendChild(image);
        return tile;
      }).filter(Boolean);
      if (tiles.length) {
        replaceChildren(mosaic, tiles);
        /* cloneNode copies focal data, not the original resize observer. */
        scanApprovedImages(mosaic);
        mosaic.dataset.vsrRandomized = '1';
      }
    });
  }

  function randomizeProducts() {
    var productCount = 9;
    var pool = document.querySelectorAll('template[data-vsr-product-template]');
    if (!pool.length) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-vsr-random-products]'), function (mosaic) {
      if (mosaic.dataset.vsrRandomized) return;
      var localProducts = sample(pool, productCount).map(function (template, index) {
        var tile = cloneTemplate(template);
        if (!tile) return null;
        tile.className = 'vsr-page-hero__product vsr-page-hero__product--' + (index + 1);
        var image = tile.querySelector('img');
        if (image && index < 2) {
          image.removeAttribute('loading');
          image.setAttribute('fetchpriority', 'high');
        }
        return tile;
      }).filter(Boolean);
      if (localProducts.length) {
        replaceChildren(mosaic, localProducts);
        mosaic.dataset.vsrRandomized = 'local';
      }

      var poolHost = mosaic.parentElement && mosaic.parentElement.querySelector('[data-vsr-product-pool]');
      var total = poolHost ? parseInt(poolHost.dataset.vsrProductCount, 10) : 0;
      var handle = poolHost && poolHost.dataset.vsrCollectionHandle;
      if (!window.fetch || !handle || !total || total <= pool.length) return;

      var samplePages = [];
      var seenPages = {};
      while (samplePages.length < Math.min(productCount, total)) {
        var samplePage = Math.floor(randomUnit() * total) + 1;
        if (seenPages[samplePage]) continue;
        seenPages[samplePage] = true;
        samplePages.push(samplePage);
      }
      var baseEndpoint = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=1&page=';
      var requests = samplePages.map(function (samplePage) {
        return window.fetch(baseEndpoint + samplePage, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) return { products: [] };
            return response.json();
          })
          .catch(function () { return { products: [] }; });
      });

      Promise.all(requests)
        .then(function (payloads) {
          var candidates = payloads.reduce(function (products, payload) {
            return products.concat(payload.products || []);
          }, []).filter(function (product) {
            return product && product.handle && product.images && product.images.length;
          });
          if (!candidates.length || !mosaic.isConnected) return;

          var chosen = sample(candidates, productCount);
          var used = {};
          var remoteTiles = chosen.map(function (product, index) {
            used[product.handle] = true;
            var imageData = product.images[0];
            var source = typeof imageData === 'string' ? imageData : imageData.src;
            if (!source) return null;
            var separator = source.indexOf('?') === -1 ? '?' : '&';
            var tile = document.createElement('div');
            tile.className = 'vsr-page-hero__product vsr-page-hero__product--' + (index + 1);
            tile.dataset.vsrProductHandle = product.handle;
            var image = document.createElement('img');
            image.src = source + separator + 'width=640';
            image.srcset = source + separator + 'width=360 360w, ' +
              source + separator + 'width=520 520w, ' + source + separator + 'width=640 640w';
            image.sizes = '(max-width: 749px) 34vw, 22vw';
            image.alt = '';
            image.width = 640;
            image.height = 640;
            image.decoding = 'async';
            if (index < 2) image.setAttribute('fetchpriority', 'high');
            else image.loading = 'lazy';
            tile.appendChild(image);
            return tile;
          }).filter(Boolean);

          if (remoteTiles.length < productCount) {
            Array.prototype.some.call(sample(pool, pool.length), function (template) {
              var productHandle = template.dataset.vsrProductHandle;
              if (used[productHandle]) return false;
              var tile = cloneTemplate(template);
              if (!tile) return false;
              used[productHandle] = true;
              tile.className = 'vsr-page-hero__product vsr-page-hero__product--' + (remoteTiles.length + 1);
              remoteTiles.push(tile);
              return remoteTiles.length === productCount;
            });
          }
          if (remoteTiles.length < productCount) return;

          var ready = remoteTiles.map(function (tile) {
            var image = tile.querySelector('img');
            if (!image || !image.decode) return Promise.resolve();
            return image.decode().catch(function () {});
          });
          return Promise.race([
            Promise.all(ready),
            new Promise(function (resolve) { setTimeout(resolve, 2500); })
          ]).then(function () {
            if (!mosaic.isConnected) return;
            replaceChildren(mosaic, remoteTiles);
            mosaic.dataset.vsrRandomized = 'catalogue';
            mosaic.dataset.vsrSamplePage = samplePages.join(',');
          });
        })
        .catch(function () {
          // The already-random local set is the resilient fallback.
        });
    });
  }

  function randomizeIndex() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vsr-random-index]'), function (index) {
      if (index.dataset.vsrRandomized) return;
      var tail = index.querySelector('.vsr-index-tail');
      var items = index.querySelectorAll(':scope > [data-vsr-index-item]');
      sample(items, items.length).forEach(function (item) {
        index.insertBefore(item, tail || null);
      });
      index.dataset.vsrRandomized = '1';
    });
  }

  function randomizeBridgeArt() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vsr-bridge-art]'), function (gallery) {
      if (gallery.dataset.vsrRandomized) return;
      var sources = Array.prototype.filter.call(
        document.querySelectorAll('[id$="__latest_releases"] .card__media img[alt]:not([alt=""])'),
        function (image) { return !!(image.currentSrc || image.src); }
      );
      var artwork = sample(sources, 4).map(function (source, index) {
        var frame = document.createElement('figure');
        frame.className = 'vsr-bridge-art';
        var image = source.cloneNode(true);
        image.alt = '';
        image.setAttribute('aria-hidden', 'true');
        image.sizes = '(max-width: 749px) 58vw, 32vw';
        image.decoding = 'async';
        if (index < 2) image.removeAttribute('loading');
        else image.loading = 'lazy';
        frame.appendChild(image);
        return frame;
      });
      if (artwork.length) {
        replaceChildren(gallery, artwork);
        scanApprovedImages(gallery);
        gallery.dataset.vsrRandomized = '1';
      }
    });
  }

  function randomizedMedia() {
    randomizeArtists();
    applyApprovedLeads();
    applyApprovedLogos();
    randomizeProducts();
    randomizeIndex();
    randomizeBridgeArt();
  }

  /* ---------- discovery controls ---------- */
  function normalized(value) {
    var text = (value || '').toLowerCase();
    if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text.replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  }

  function rosterDiscovery() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vsr-roster-tools]'), function (tools) {
      if (tools.dataset.vsrReady) return;
      var input = tools.querySelector('[data-vsr-roster-search]');
      var clear = tools.querySelector('[data-vsr-roster-clear]');
      var section = tools.closest('.vsr-roster-section');
      var grid = section && section.querySelector('.vsr-roster-grid');
      var empty = section && section.querySelector('[data-vsr-roster-empty]');
      var count = section && section.querySelector('[data-vsr-roster-count]');
      if (!input || !clear || !grid) return;
      var cards = grid.querySelectorAll('.vsr-artist-card');

      function filterRoster() {
        var query = normalized(input.value);
        var words = query.split(' ').filter(Boolean);
        var compactQuery = query.replace(/ /g, '');
        var visibleCards = 0;
        Array.prototype.forEach.call(cards, function (card) {
          var fields = Array.prototype.map.call(card.querySelectorAll(
            '.vsr-artist-name, .vsr-artist-genre, .vsr-artist-loc'), function (field) {
            return field.textContent;
          });
          fields.push(card.dataset.vsrArtistHandle || '');
          var text = normalized(fields.join(' '));
          var match = !query || text.replace(/ /g, '').indexOf(compactQuery) !== -1 ||
            words.every(function (word) { return text.indexOf(word) !== -1; });
          card.hidden = !match;
          if (match) visibleCards++;
        });
        clear.hidden = !query;
        if (empty) empty.hidden = visibleCards !== 0;
        if (count) count.textContent = visibleCards + ' / ' + cards.length;
        grid.classList.toggle('is-filtering', !!query);
      }

      input.addEventListener('input', filterRoster);
      input.addEventListener('search', filterRoster);
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          input.value = '';
          filterRoster();
        }
      });
      clear.addEventListener('click', function () {
        input.value = '';
        filterRoster();
        input.focus();
      });
      tools.dataset.vsrReady = '1';
      filterRoster();
      window.addEventListener('pageshow', filterRoster);
    });
  }

  function artistDestinations() {
    var destinations = [];
    Array.prototype.forEach.call(document.querySelectorAll('template[data-vsr-artist-template]'), function (template) {
      if (template.dataset.vsrArtistHandle === 'beboo') return;
      var link = template.content && template.content.querySelector('a[href]');
      if (link && link.getAttribute('href')) destinations.push(link.getAttribute('href'));
    });
    if (destinations.length) return destinations;
    Array.prototype.forEach.call(document.querySelectorAll('.vsr-roster-grid a.vsr-artist-card'), function (link) {
      if (link.dataset.vsrArtistHandle !== 'beboo') destinations.push(link.getAttribute('href'));
    });
    return destinations;
  }

  function discoveryDoors() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vsr-random-artist-link]'), function (link) {
      if (link.dataset.vsrReady) return;
      link.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var destinations = artistDestinations();
        if (!destinations.length) return;
        event.preventDefault();
        window.location.assign(destinations[Math.floor(randomUnit() * destinations.length)]);
      });
      link.dataset.vsrReady = '1';
    });

    Array.prototype.forEach.call(
      document.querySelectorAll('[data-vsr-random-product-link], [data-vsr-random-product-door]'),
      function (link) {
        if (link.dataset.vsrReady) return;
        link.addEventListener('click', function (event) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          var total = parseInt(link.dataset.vsrProductCount, 10);
          if (!window.fetch || !total || link.getAttribute('aria-busy') === 'true') return;
          event.preventDefault();
          var fallback = link.href;
          var page = Math.floor(randomUnit() * total) + 1;
          link.setAttribute('aria-busy', 'true');
          link.classList.add('is-tuning');
          window.fetch('/collections/all/products.json?limit=1&page=' + page, { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) throw new Error('Random object unavailable');
              return response.json();
            })
            .then(function (payload) {
              var product = payload.products && payload.products[0];
              if (!product || !product.handle) throw new Error('Random object unavailable');
              window.location.assign('/products/' + encodeURIComponent(product.handle));
            })
            .catch(function () { window.location.assign(fallback); });
        });
        link.dataset.vsrReady = '1';
      }
    );
  }

  /* ---------- mobile product purchase rail ---------- */
  function productDock() {
    if (document.querySelector('[data-vsr-product-dock]')) return;
    var original = document.querySelector('#MainContent .product-form__submit');
    if (!original) return;
    var info = original.closest('.product__info-container') || original.parentElement;
    var dock = document.createElement('div');
    dock.className = 'vsr-product-dock';
    dock.setAttribute('data-vsr-product-dock', '');
    dock.setAttribute('aria-hidden', 'true');

    var copy = document.createElement('span');
    copy.className = 'vsr-product-dock__copy';
    var overline = document.createElement('small');
    overline.textContent = 'Selected edition';
    var price = document.createElement('strong');
    price.setAttribute('data-vsr-product-dock-price', '');
    copy.appendChild(overline);
    copy.appendChild(price);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'vsr-product-dock__button';
    button.setAttribute('data-vsr-product-dock-button', '');
    button.setAttribute('aria-label', 'Add selected edition to cart');
    dock.appendChild(copy);
    dock.appendChild(button);
    document.body.appendChild(dock);

    function visiblePrice() {
      var prices = info ? info.querySelectorAll('.price-item') : [];
      for (var i = 0; i < prices.length; i++) {
        var style = getComputedStyle(prices[i]);
        if (style.display !== 'none' && style.visibility !== 'hidden' && prices[i].getBoundingClientRect().width) {
          return prices[i].textContent.replace(/\s+/g, ' ').trim();
        }
      }
      return '';
    }

    function syncDock() {
      var label = original.textContent.replace(/\s+/g, ' ').trim();
      button.disabled = !!original.disabled;
      button.textContent = original.disabled ? (label || 'Unavailable') : 'Add this edition';
      price.textContent = visiblePrice();
      dock.classList.toggle('is-disabled', !!original.disabled);
    }

    var ticking = false;
    function placeDock() {
      ticking = false;
      var rect = original.getBoundingClientRect();
      var footer = document.querySelector('footer');
      var footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
      var originalVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      var show = window.scrollY > 220 && !originalVisible && !footerVisible;
      dock.classList.toggle('is-visible', show);
      dock.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function requestPlace() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(placeDock);
    }

    button.addEventListener('click', function () {
      dock.classList.remove('is-visible');
      dock.setAttribute('aria-hidden', 'true');
      if (!original.disabled) original.click();
      setTimeout(requestPlace, 400);
    });
    window.addEventListener('scroll', requestPlace, { passive: true });
    window.addEventListener('resize', requestPlace, { passive: true });
    var observer = new MutationObserver(function () { syncDock(); requestPlace(); });
    observer.observe(info || original, { attributes: true, childList: true, characterData: true, subtree: true });
    syncDock();
    placeDock();
  }

  /* ---------- 1. load curtain ---------- */
  function curtain() {
    if (reduced || sessionStorage.getItem('vsrSeen')) return;
    var c = document.createElement('div');
    c.className = 'vsr-curtain';
    c.innerHTML = '<div style="text-align:center">' +
                  '<span>Voyager Sound Records</span><i></i></div>';
    document.body.appendChild(c);
    var lift = function () {
      c.classList.add('is-gone');
      setTimeout(function () { c.remove(); }, 900);
      try { sessionStorage.setItem('vsrSeen', '1'); } catch (e) {}
    };
    if (document.readyState === 'complete') setTimeout(lift, 700);
    else window.addEventListener('load', function () { setTimeout(lift, 700); });
    setTimeout(lift, 3000);            // never trap the visitor
  }

  /* ---------- 2. cursor ring ---------- */
  function ring() {
    if (!fine || reduced) return;
    var r = document.createElement('div');
    r.className = 'vsr-ring';
    document.body.appendChild(r);
    var x = 0, y = 0, cx = 0, cy = 0, on = false, raf = 0;
    function animate() {
      cx += (x - cx) * 0.18;
      cy += (y - cy) * 0.18;
      r.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      if (on && (Math.abs(x - cx) > 0.08 || Math.abs(y - cy) > 0.08)) {
        raf = requestAnimationFrame(animate);
      } else {
        raf = 0;
      }
    }
    function requestAnimate() {
      if (!raf) raf = requestAnimationFrame(animate);
    }
    document.addEventListener('pointermove', function (e) {
      x = e.clientX; y = e.clientY;
      if (!on) { on = true; r.classList.add('is-on'); cx = x; cy = y; }
      requestAnimate();
    }, { passive: true });
    document.addEventListener('pointerleave', function () {
      on = false; r.classList.remove('is-on');
    }, { passive: true });
    // grow over anything clickable
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest('a,button,[role=button],.card-wrapper,.vsr-sleeve');
      r.classList.toggle('is-big', !!t);
    }, { passive: true });
  }

  /* ---------- 3. marquee dividers between sections ---------- */
  var MARQUEE = [
    'Voyager Sound Records', 'Artists worldwide', 'New releases every week',
    'Independent music from every corner of the globe', 'Release artwork made tangible',
    'Shipped worldwide', 'Lossless wherever you listen'
  ];
  function marquees() {
    var anchors = document.querySelectorAll('[data-vsr-marquee]');
    Array.prototype.forEach.call(anchors, build);
    function build(host) {
      if (host.dataset.vsrDone) return;
      host.dataset.vsrDone = '1';
      var wrap = document.createElement('div');
      wrap.className = 'vsr-marquee';
      var track = document.createElement('div');
      track.className = 'vsr-marquee-track';
      var items = MARQUEE.concat(MARQUEE, MARQUEE);
      track.innerHTML = items.map(function (t, i) {
        return (i % 3 === 0 ? '<b>' + t + '</b>' : '<span>' + t + '</span>') +
               '<span>&middot;</span>';
      }).join('');
      wrap.appendChild(track);
      host.appendChild(wrap);
      // CSS animation instead of a rAF loop: the compositor owns it, so it
      // costs nothing on the main thread and keeps running during scroll.
      track.style.setProperty('--vsr-marquee-w', (track.scrollWidth / 3) + 'px');
      track.classList.add('is-running');
    }
  }

  /* ---------- 4. product cards -> record sleeves ---------- */
  function sleeves() {
    var cards = document.querySelectorAll('.card-wrapper, .card__inner');
    Array.prototype.forEach.call(cards, function (card) {
      var media = card.querySelector('.card__media, .media, img');
      if (!media) return;
      var host = media.closest('.card__media') || media.parentElement;
      if (!host || host.dataset.vsrSleeve) return;
      host.dataset.vsrSleeve = '1';
      host.classList.add('vsr-sleeve');
      var cat = document.createElement('span');
      cat.className = 'vsr-sleeve-cat';
      cat.textContent = 'VSR·EDITION';
      host.appendChild(cat);
    });
  }

  /* ---------- 5. section kickers ---------- */
  var KICKERS = {
    'new objects from recent releases': 'Selected objects',
    'the roster': 'Every artist',
    'start with the sound.': 'Listen first',
    'stay close to the signal': 'Private transmission'
  };
  function kickers() {
    var hs = document.querySelectorAll('.shopify-section h2');
    Array.prototype.forEach.call(hs, function (h) {
      if (h.dataset.vsrKick) return;
      var key = (h.textContent || '').trim().toLowerCase();
      var label = KICKERS[key];
      if (!label) return;
      h.dataset.vsrKick = '1';
      var k = document.createElement('div');
      k.className = 'vsr-kicker';
      k.textContent = label;
      h.parentNode.insertBefore(k, h);
    });
  }

  /* ---------- 6. equaliser wherever asked for ---------- */
  function eq() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vsr-eq]'), function (host) {
      if (host.dataset.vsrDone) return;
      host.dataset.vsrDone = '1';
      var e = document.createElement('div');
      e.className = 'vsr-eq';
      for (var i = 0; i < 14; i++) {
        var b = document.createElement('i');
        b.style.animationDelay = (i * 0.07).toFixed(2) + 's';
        e.appendChild(b);
      }
      host.appendChild(e);
    });
  }

  function boot() {
    randomizedMedia(); rosterDiscovery(); discoveryDoors(); productDock();
    curtain(); ring(); marquees(); sleeves(); kickers(); eq();
    // Shopify re-renders sections on cart/filter events; re-decorate then.
    document.addEventListener('shopify:section:load', function () {
      randomizedMedia(); rosterDiscovery(); discoveryDoors(); productDock();
      sleeves(); kickers(); marquees(); eq();
    });
    var mo = new MutationObserver(function () { sleeves(); });
    mo.observe(document.body, { childList: true, subtree: true });
    document.documentElement.classList.add('vsr-editorial-on');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
